import { render } from "./Approve.vue?vue&type=template&id=50fa327a"
import script from "./Approve.vue?vue&type=script&lang=ts"
export * from "./Approve.vue?vue&type=script&lang=ts"
script.render = render

export default script